<template>
  <div>
    <form novalidate @submit.prevent="submit">
      <div class="row text-center">
        <div
          class="caixa-login col-xs-offset-2 col-sm-offset-4 col-md-offset-4 col-lg-offset-4 col-xs-8 col-sm-4 col-md-4 col-lg-4"
        >
          <h1 id="logo" class="logo"> cardea </h1>
          <br /><br />
          <div
            id="emailGroup"
            :class="{ 'has-error': v$.email.$error }"
            class="form-group"
          >
            <label class="sr-only" for="email"> E-mail </label>
            <div class="input-group">
              <div class="input-group-addon">
                <i class="fa fa-user" aria-hidden="true" />
              </div>
              <input
                id="email"
                v-model="email"
                data-test-id="input-esqueci-senha-email"
                type="email"
                name="email"
                class="form-control"
                placeholder="E-mail"
                :readonly="enviado"
                @input="v$.email.$touch()"
              />
            </div>
          </div>
          <div
            class="text-left"
            :class="[enviado && 'text-success', erro && 'text-danger']"
            style="margin: 2px 4px 18px 4px"
          >
            <span v-if="erro && !enviado">
              {{ erro }}
            </span>
            <span v-if="enviado">
              Verifique as instruções enviadas para o email para gerar uma nova
              senha.
            </span>
            <span v-else>
              Infome o email para receber link de cadastro de nova senha
            </span>
          </div>
          <button
            data-test-id="button-esqueci-senha-confirmar"
            type="submit"
            class="btn btn-primary btn-block"
            :disabled="enviado"
          >
            Confirmar
          </button>
          <br />
          <br />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { email, required } from '@vuelidate/validators'

import Autenticacao from '@/servicos/Autenticacao'

const autenticacao = new Autenticacao()

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      email: '',
      enviado: false,
      erro: null,
    }
  },
  methods: {
    submit() {
      if (this.v$.$invalid) {
        this.v$.$touch()
        this.$alert({ content: 'Informe o email.' })
      } else {
        autenticacao
          .solicitarNovaSenha(this.email)
          .then((result) => {
            this.enviado = true
            this.erro = null
          })
          .catch((err) => {
            this.enviado = false
            console.error(err)
            this.erro = 'Erro ao solicitar recuperação da senha'
          })
      }
    },
  },
  validations: {
    email: { required, email },
  },
}
</script>

<style scoped>
.caixa-login {
  padding: 50px 50px 10px 50px !important;
  margin-top: 40px;
  background-color: #f7f9f9;
  box-shadow: 0 6px 32px rgba(0, 0, 0, 0.175);
}

.logo {
  position: relative;
  display: inline;
  margin-left: -36px;
  font-family: 'Crushed', Arial, Helvetica, sans-serif !important;
  font-size: 8em;
  font-weight: 400px;
  color: rgba(18, 128, 128, 0.5);
  letter-spacing: -7px;
}

.logo::after {
  position: absolute;
  top: 4px;
  left: 7px;
  color: rgba(128, 128, 18, 0.5);
  content: 'cardea';
}
</style>
